import React, { useState } from 'react';
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";
import axios from "axios";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/login`, {
                username,
                password,
                credentials: "include"
            });
            
            localStorage.setItem("token", response.data.token);
            window.location.href = "/admin";
        } catch (error) {
            console.error("Fehler beim Login:", error);
            setError("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.");
        }
    };

    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <div className="w-full"></div>

            <div className="flex w-full mb-[600px] items-center justify-center">
                <div>
                    <h1 className="text-3xl text-center mt-4">Admin Login</h1>
                    <form onSubmit={handleLogin} className="mt-12 flex-1">
                        <input
                            type="text"
                            placeholder="Benutzername"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            className="flex w-80 mb-6 h-8 pointer-events-auto rounded-lg pl-2"
                        />
                        <input
                            type="password"
                            placeholder="Passwort"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            className="flex w-80 mb-6 h-8 pointer-events-auto rounded-lg pl-2"
                        />
                        <button className="flex bg-blue-500 rounded-lg py-2 px-5 justify-center text-white hover:ring-2 w-full"
                                type="submit">Login
                        </button>
                    </form>
                    {error && <p style={{color: 'red'}}>{error}</p>}
                </div>
            </div>

            <div className="w-full m-12"></div>

            <Footer/>
        </div>
    );
};

export default Login;
